// components/ui/spinner.tsx
import React from 'react';
import {cn} from '@purpose/ui/lib/utils';

type SpinnerProps = {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

export const Spinner = ({size = 'md', className}: SpinnerProps) => {
  const sizeClasses = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-6 w-6'
  };

  return (
    <div
      className={cn(
        'animate-spin rounded-full border-2 border-black border-t-transparent',
        sizeClasses[size],
        className
      )}
    />
  );
};
